var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { class: [_vm.bemRoot, _vm.bemFacets] }, [
    _vm.itemsPaths.length
      ? _c(
          "ul",
          { staticClass: "language-menu--collection u-reset" },
          _vm._l(_vm.items, function(item, index) {
            return _c(
              "li",
              { key: index, staticClass: "language-menu--item" },
              [
                _c(
                  "a",
                  {
                    staticClass: "language-menu--link u-reset",
                    class: _vm.getLinkClasses(item),
                    attrs: { href: _vm.itemsPaths[index] }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(item.abbr) +
                        "\n            "
                    )
                  ]
                )
              ]
            )
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22008202", { render: render, staticRenderFns: staticRenderFns })
  }
}